import React, {useState, useEffect} from "react";
import "./AddressSelect.scss";
import AddAddressModal from "../../ModalPages/AddAddressModal";
import axios from "axios";
import {toast} from "react-toastify";
import {prefixUrl} from "../../../Utils/utilsData";
import SmallModal from "../../ModalPages/SmallModal";
import AlertPopupIcon from '../../../Assets/svg/alert-popup.svg'

const AddressSelect = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const [currentAddress, setCurrentAddress] = useState();
  const [addressData, setAddressData] = useState([]);
  const [request, setRequest] = useState(false);
  const [formValues, setFormValues] = useState("");
  const [type, setType] = useState("add");
  const [deleteId, setDeleteId] = useState("");
  const [isLoad, setIsLoad] = useState(false);

  const removeAddress = (id) => {
    axios
      .post(`${prefixUrl()}/address/delete.php`, {
        addressId: id,
      })
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          setShowDelModal(false);
          setRequest(!request);
        } else {
          toast.error(response.data.message);
        }
      });
  };

  useEffect(() => {
    axios.get(`${prefixUrl()}/address/get.php`).then((response) => {
      if (response.data.status) {
        setAddressData(response.data.message);
        setIsLoad(true)
      } else {
        toast.error("خطا در بر قراری ارتباط")
      }
    });
  }, [request]);

  const selectAddress = (id, i) => {
    if (props.onSelect) {
      props.onSelect("addressId", id);
      setCurrentAddress(i);
    }
  };
  const addAddress = () => {
    setType("add");
    setFormValues("");
    setShowModal(true);
  };
  const getAddress = (id) => {
    for (let item of addressData) {
      if (item.id === id) {
        setFormValues(item);
        setType("edit");
        setShowModal(true);
      }
    }
  };
  const deleteAddress = (id) => {
    setShowDelModal(true);
    setDeleteId(id);
  };

  useEffect(() => {
    if (isLoad && addressData.length > 0) {
      if (props.onSelect) {
        props.onSelect("addressId", addressData[0].id);
        setCurrentAddress(0);
      }
    }
  }, [isLoad, addressData]);

  try {
    return (
      <div className="main-address">
        {addressData?.map((v, index) => (
          <div
            className={
              currentAddress === index ? "box-address activeAdd" : "box-address"
            }
            key={"Ad" + index}
            onClick={() => selectAddress(v.id, index)}
          >
            <div className="title-address">
              <h5>{v.title}</h5>
              <div style={{display: "flex", columnGap: "8px"}}>
                <svg
                  onClick={() => getAddress(v.id)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M22 13V15C22 20 20 22 15 22H9C4 22 2 20 2 15V13.48"
                    stroke="#40B2AA"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11 2H9C4 2 2 4 2 9"
                    stroke="#40B2AA"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.9299 9.01001L20.9799 7.96001C22.3399 6.60001 22.9799 5.02001 20.9799 3.02001C18.9799 1.02001 17.3999 1.66001 16.0399 3.02001L8.15988 10.9C7.85988 11.2 7.55988 11.79 7.49988 12.22L7.06988 15.23C6.90988 16.32 7.67988 17.08 8.76988 16.93L11.7799 16.5C12.1999 16.44 12.7899 16.14 13.0999 15.84L16.2799 12.66L17.0099 11.93"
                    stroke="#40B2AA"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899"
                    stroke="#40B2AA"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  onClick={() => deleteAddress(v.id)}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="close-circle 2">
                    <path
                      id="Vector"
                      d="M13.9902 10.0099L14.8302 9.16992"
                      stroke="#EB455F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_2"
                      d="M9.16992 14.8301L11.9199 12.0801"
                      stroke="#EB455F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_3"
                      d="M14.8299 14.8299L9.16992 9.16992"
                      stroke="#EB455F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      id="Vector_4"
                      d="M4 6C2.75 7.67 2 9.75 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C10.57 2 9.2 2.3 7.97 2.85"
                      stroke="#EB455F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
              </div>
            </div>

            <div className="row-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="map 1">
                  <path
                    id="Vector"
                    d="M7.62435 6.24023C7.15768 6.24023 6.79102 6.61523 6.79102 7.07357C6.79102 7.5319 7.16602 7.9069 7.62435 7.9069C8.08268 7.9069 8.45765 7.5319 8.45765 7.07357C8.45765 6.61523 8.08268 6.24023 7.62435 6.24023Z"
                    fill="#B9B9B9"
                  />
                  <path
                    id="Vector_2"
                    d="M17.8827 4.19996C17.1827 2.57496 15.641 1.66663 13.491 1.66663H6.50768C3.83268 1.66663 1.66602 3.83329 1.66602 6.50829V13.4916C1.66602 15.6416 2.57435 17.1833 4.19935 17.8833C4.35768 17.95 4.54102 17.9083 4.65768 17.7916L17.791 4.65829C17.916 4.53329 17.9577 4.34996 17.8827 4.19996ZM8.77435 10.2C8.44935 10.5166 8.02435 10.6666 7.59935 10.6666C7.17435 10.6666 6.74935 10.5083 6.42435 10.2C5.57435 9.39996 4.64102 8.12496 4.99935 6.60829C5.31602 5.23329 6.53268 4.61663 7.59935 4.61663C8.66602 4.61663 9.88268 5.23329 10.1993 6.61663C10.5493 8.12496 9.61602 9.39996 8.77435 10.2Z"
                    fill="#B9B9B9"
                  />
                  <path
                    id="Vector_3"
                    d="M16.2241 17.1079C16.4074 17.2913 16.3824 17.5913 16.1574 17.7163C15.4241 18.1246 14.5324 18.3329 13.4908 18.3329H6.50743C6.26577 18.3329 6.16577 18.0496 6.33243 17.8829L11.3658 12.8496C11.5324 12.6829 11.7908 12.6829 11.9574 12.8496L16.2241 17.1079Z"
                    fill="#B9B9B9"
                  />
                  <path
                    id="Vector_4"
                    d="M18.3354 6.50743V13.4907C18.3354 14.5324 18.1271 15.4324 17.7187 16.1574C17.5937 16.3824 17.2937 16.3991 17.1104 16.2241L12.8438 11.9574C12.6771 11.7907 12.6771 11.5324 12.8438 11.3657L17.8771 6.33243C18.0521 6.16577 18.3354 6.26577 18.3354 6.50743Z"
                    fill="#B9B9B9"
                  />
                </g>
              </svg>
              <p>
                {v.fullName}
                &nbsp;
                {v.city}
              </p>
            </div>

            <div className="row-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="location 2">
                  <path
                    id="Vector"
                    d="M17.1849 7.04171C16.3099 3.19171 12.9516 1.45837 10.0016 1.45837C10.0016 1.45837 10.0016 1.45837 9.99324 1.45837C7.05154 1.45837 3.68488 3.18337 2.80988 7.03337C1.83488 11.3334 4.46821 14.975 6.85154 17.2667C7.73488 18.1167 8.86824 18.5417 10.0016 18.5417C11.1349 18.5417 12.2682 18.1167 13.1432 17.2667C15.5266 14.975 18.1599 11.3417 17.1849 7.04171ZM10.0016 11.2167C8.55157 11.2167 7.37654 10.0417 7.37654 8.59171C7.37654 7.14171 8.55157 5.96671 10.0016 5.96671C11.4516 5.96671 12.6266 7.14171 12.6266 8.59171C12.6266 10.0417 11.4516 11.2167 10.0016 11.2167Z"
                    fill="#B9B9B9"
                  />
                </g>
              </svg>
              <p>{v.address}</p>
            </div>

            <div className="row-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="call 2">
                  <path
                    id="Vector"
                    d="M10.7923 12.4583L12.334 14C12.659 14.325 13.1757 14.325 13.509 14.0083C13.6007 13.9166 13.6923 13.8333 13.784 13.7416C14.6423 12.875 15.4173 11.9666 16.109 11.0166C16.7923 10.0666 17.3423 9.11663 17.7423 8.17496C18.134 7.22496 18.334 6.31663 18.334 5.44996C18.334 4.88329 18.234 4.34163 18.034 3.84163C17.834 3.33329 17.5173 2.86663 17.0757 2.44996C16.5423 1.92496 15.959 1.66663 15.3423 1.66663C15.109 1.66663 14.8757 1.71663 14.6673 1.81663C14.4507 1.91663 14.259 2.06663 14.109 2.28329L12.1757 5.00829C12.0257 5.21663 11.9173 5.40829 11.8423 5.59163C11.7673 5.76663 11.7257 5.94163 11.7257 6.09996C11.7257 6.29996 11.784 6.49996 11.9007 6.69163C12.009 6.88329 12.1673 7.08329 12.3673 7.28329L13.0007 7.94163C13.0923 8.03329 13.134 8.14163 13.134 8.27496C13.134 8.34163 13.1257 8.39996 13.109 8.46663C13.084 8.53329 13.059 8.58329 13.0423 8.63329C12.8923 8.90829 12.634 9.26663 12.2673 9.69996C11.8923 10.1333 11.4923 10.575 11.059 11.0166C10.9757 11.1 10.884 11.1833 10.8007 11.2666C10.4673 11.5916 10.459 12.125 10.7923 12.4583Z"
                    fill="#B9B9B9"
                  />
                  <path
                    id="Vector_2"
                    d="M1.69167 15.2742C1.69167 15.5076 1.73334 15.7492 1.81668 15.9826C1.84168 16.0492 1.86667 16.1159 1.90001 16.1826C2.04167 16.4826 2.22501 16.7659 2.46668 17.0326C2.87501 17.4826 3.32501 17.8076 3.83334 18.0159C3.84168 18.0159 3.85001 18.0242 3.85834 18.0242C4.35001 18.2242 4.88334 18.3326 5.45834 18.3326C6.30834 18.3326 7.21668 18.1326 8.17501 17.7242C9.13334 17.3159 10.0917 16.7659 11.0417 16.0742C11.3667 15.8326 11.6917 15.5909 12 15.3326L9.27501 12.6076C9.04168 12.7826 8.83334 12.9159 8.65834 13.0076C8.61668 13.0242 8.56668 13.0492 8.50834 13.0742C8.44168 13.0992 8.37501 13.1076 8.30001 13.1076C8.15834 13.1076 8.05001 13.0576 7.95834 12.9659L7.32501 12.3409C7.11668 12.1326 6.91668 11.9742 6.72501 11.8742C6.53334 11.7576 6.34167 11.6992 6.13334 11.6992C5.97501 11.6992 5.80834 11.7326 5.62501 11.8076C5.44168 11.8826 5.25001 11.9909 5.04168 12.1326L2.28334 14.0909C2.06668 14.2409 1.91667 14.4159 1.82501 14.6242C1.74167 14.8326 1.69167 15.0409 1.69167 15.2742Z"
                    fill="#B9B9B9"
                  />
                </g>
              </svg>
              <p>{v.mobile}</p>
            </div>
          </div>
        ))}

        <div className="add-address" onClick={addAddress}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="none"
            viewBox="0 0 36 36"
          >
            <g
              stroke="#40b2aa"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path
                d="M22.682 15.465c0 2.58-2.085 4.68-4.68 4.68a4.667 4.667 0 01-4.68-4.68c0-2.595 2.1-4.68 4.68-4.68.51 0 1.005.075 1.455.225"></path>
              <path
                d="M8.971 6.45c6.555-6.165 19.26-4.05 21.6 6.315 1.725 7.62-3.015 14.07-7.17 18.06-3.015 2.91-7.785 2.91-10.815 0C8.446 26.82 3.691 20.37 5.431 12.75"></path>
            </g>
          </svg>
          <p>افزودن آدرس</p>
        </div>

        {showModal && (
          <AddAddressModal
            onClose={() => setShowModal(false)}
            onAdd={() => setRequest(!request)}
            add={request}
            formvalues={formValues}
            type={type}
          />
        )}
        {showDelModal && (
          <SmallModal
            onClose={() => setShowDelModal(false)}
            onOp1={() => setShowDelModal(false)}
            onOp2={() => removeAddress(deleteId)}
            title={"آیا از حذف این مورد اطمینان دارید ؟"}
            icon={AlertPopupIcon}
            op1={"خیر، منصرف شدم"}
            op2={"بله، مطمئن هستم"}
          />
        )}
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }

};
export default AddressSelect;
